import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { AppSvgIconComponent } from '@vallift/ngl';
import { AuthService } from '@core/services/auth.service';
import { TokenStorageService } from '@core/services/token-storage.service';
import type { SignupUserResponse } from '@core/api/workspace/models';

@Component({
  selector: 'app-account-menu-button',
  standalone: true,
  imports: [AppSvgIconComponent, CdkMenuTrigger, CdkMenu, CdkMenuItem],
  templateUrl: './account-menu-button.html',
})
export class AccountMenuButtonComponent {
  private readonly authService = inject(AuthService);
  private readonly tokenStorage = inject(TokenStorageService);
  private readonly router = inject(Router);

  get user(): SignupUserResponse | null {
    return this.tokenStorage.getUser();
  }

  get displayName(): string {
    const name = this.user?.name?.trim();
    if (name) {
      return name;
    }
    return this.user?.email ?? 'Account';
  }

  get email(): string {
    return this.user?.email ?? '';
  }

  get pictureUrl(): string | null {
    return this.user?.picture?.trim() || null;
  }

  get initial(): string {
    const source = this.displayName;
    return source ? source.charAt(0).toUpperCase() : 'U';
  }

  onAccountSettings(): void {
    void this.router.navigate(['/settings']);
  }

  onLogout(): void {
    this.authService.logout();
  }
}
